/*eslint-env node*/
exports.transformFieldName = function transformFieldName (fieldName) {
  return fieldName.replace(/[-_]([a-z0-9])/g, (m, c) => c.toUpperCase());
};
